export { default } from './src/filterable-item';
